module.exports = __webpack_public_path__ + "static/media/spinner.795343f4.svg";